import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function verificationCodeValidator(control: AbstractControl): ValidationErrors | null {
  const value = (control.value || '').trim();
  const isValid = /^\d{6}$/.test(value);

  if (!isValid) {
    return { invalidCode: true };
  }
  return null;
}
